import { AfterViewInit, Component, ElementRef, inject, Inject, ViewChild } from '@angular/core';
import { NZ_MODAL_DATA, NzModalTitleDirective, NzModalFooterDirective, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { ScrapDto } from 'src/app/shared/dto/scrap.dto';
import { NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzTbodyComponent } from 'ng-zorro-antd/table';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { DatePipe, DecimalPipe } from '@angular/common';
import { TITLE_TABLE_SIZE } from 'src/app/core/constants/style';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { getDisplayUnit } from 'src/app/shared/utils/utils';

@Component({
    selector: 'app-modal-watch-scraps',
    templateUrl: './modal-watch-scraps.component.html',
    styleUrls: ['./modal-watch-scraps.component.scss'],
    standalone: true,
    imports: [
        NzModalTitleDirective,
        NzTableComponent,
        NzTheadComponent,
        NzTrDirective,
        NzTableCellDirective,
        NzThMeasureDirective,
        NzTbodyComponent,
        NzModalFooterDirective,
        NzEmptyModule,
        NzMessageModule,
        DatePipe,
        DecimalPipe,
        LoaderComponent
    ]
})
export class ModalWatchScrapsComponent implements AfterViewInit {
    @ViewChild('modalContent') private readonly _modalContent!: ElementRef;

    isLoading: boolean = true;
    scraps: ScrapDto[] = [];
    productionProcessId!: number;
    tableHeight!: number;

    private readonly modalRef = inject(NzModalRef);
    private readonly message = inject(NzMessageService);

    /**
     * Devuelve la unidad de medida a mostrar según el proceso de producción
     */
    getDisplayUnit(): string {
        return getDisplayUnit(this.productionProcessId, undefined, this.scraps[0]?.finalProduct?.article?.measurementUnit?.abbreviation || '');
    }

    constructor(@Inject(NZ_MODAL_DATA) public data: { nzTitle: string, processId: number, scraps: ScrapDto[], productionProcessId: number }) {
        this.scraps = (data?.scraps as ScrapDto[]) ?? [];
        this.productionProcessId = data?.productionProcessId;

        if (!this.productionProcessId) {
            this.message.error('No se ha proporcionado el ID del proceso de producción');
            this.modalRef.close();
            return;
        }

        this.isLoading = false;
    }

    async ngAfterViewInit(): Promise<void> {
        setTimeout(() => {
            this.tableHeight =
                (this._modalContent.nativeElement as HTMLImageElement)
                    .clientHeight - TITLE_TABLE_SIZE;
        });
    }

    handleCancel(): void {
        this.modalRef.close();
    }
}